import React from 'react';
import { Box, CircularProgress } from '@mui/material';

interface Props {
  filled: boolean;
}

const Loader = ({ filled }: Props) => {
  const fillStyles = {
    position: 'absolute',
    alignItems: 'flex-start',
    background: 'rgba(255,255,255, .7)',
    top: -12,
    paddingTop: '30px',
    right: 0,
    left: -48,
    bottom: 0,
    width: 'calc(100% + 98px)',
    height: 'calc(100vh - 90px)',
    zIndex: 500
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', ...(filled && fillStyles) }}>
      <CircularProgress />
    </Box>
  );
};

export default Loader;
